import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OperatorStatusService } from '@shared/shared/services/operator-status.service';
import { OperatorStatus } from '@shared/core/types/operator';
import intervalToDuration from 'date-fns/intervalToDuration';
import { registerTranslationsManually } from '@skyeng/libs/shared/i18n';
import { TranslocoService } from '@ngneat/transloco';
import { DecorateUntilDestroy, takeUntilDestroyed } from '@skyeng/libs/shared/rxjs';

@DecorateUntilDestroy()
@Component({
  selector: 'crm-operator-statuses',
  templateUrl: './operator-statuses.component.html',
  styleUrls: ['./operator-statuses.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperatorStatusesComponent implements OnInit, OnDestroy {
  currentStatus$ = this.operatorStatusService.operatorStatus$;
  availableStatuses$ = new BehaviorSubject(this.operatorStatusService.getAvailableStatuses());
  currentStatusTime$: BehaviorSubject<string | null> = new BehaviorSubject(null);

  enabled$ = this.operatorStatusService.enabled$;

  readonly statusesLabels: { [statusName: string]: string } = {
    [OperatorStatus.WorkingOnTasks]: 'crmOperatorStatuses.workingOnTasks',
    [OperatorStatus.Break]: 'crmOperatorStatuses.break',
    [OperatorStatus.Training]: 'crmOperatorStatuses.training',
    [OperatorStatus.Meeting]: 'crmOperatorStatuses.meeting',
    [OperatorStatus.AdministrativeWork]: 'crmOperatorStatuses.administrativeWork',
    [OperatorStatus.WorkingInAnotherDep]: 'crmOperatorStatuses.workingInAnotherDep',
    [OperatorStatus.Offline]: 'crmOperatorStatuses.offline',
  };

  constructor(private operatorStatusService: OperatorStatusService, private translocoService: TranslocoService) {
    registerTranslationsManually(
      'crmOperatorStatuses',
      this.translocoService,
      import.meta.webpackContext!('./translation'),
    );
  }

  ngOnInit(): void {
    let timerInterval: number | null = null;
    const updateDateCallback = (value: number): void => {
      const duration = intervalToDuration({
        start: value,
        end: Date.now(),
      });

      this.currentStatusTime$.next(
        `${duration.hours}:`.padStart(3, '0') +
          `${duration.minutes}:`.padStart(3, '0') +
          `${duration.seconds}`.padStart(2, '0'),
      );
    };

    this.operatorStatusService.operatorStatusTime$.pipe(takeUntilDestroyed(this)).subscribe(value => {
      if (timerInterval !== null) {
        clearInterval(timerInterval);
      }

      if (null !== value) {
        updateDateCallback(value);
        timerInterval = setInterval(() => {
          updateDateCallback(value);
        }, 1000) as unknown as number;
      }
    });
  }

  changeCurrentStatus(newStatus: OperatorStatus): void {
    this.operatorStatusService.changeStatus(newStatus);
  }

  ngOnDestroy(): void {}
}
